/* eslint-disable react/prop-types */
import React from 'react';
import { Spin, Tooltip } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { formatChatRelativeTime } from '../../services/aiInsightsApi';

/**
 * Ask Evans chat history sidebar — Asset IQ–style session list.
 */
const SpacerLogAiChatSidebar = ({
  sessions = [],
  activeId = null,
  loading = false,
  onNewChat,
  onSelect,
  onDelete,
}) => (
  <aside className="spacer-ask-evans__sidebar" aria-label="Chat history">
    <button type="button" className="spacer-ask-evans__sidebar-new" onClick={onNewChat}>
      <PlusOutlined />
      <span>New chat session</span>
    </button>

    <div className="spacer-ask-evans__sidebar-label">Chat history</div>

    <div className="spacer-ask-evans__sidebar-list">
      {loading ? (
        <div className="spacer-ask-evans__sidebar-empty">
          <Spin size="small" />
        </div>
      ) : null}

      {!loading && !sessions.length ? (
        <div className="spacer-ask-evans__sidebar-empty">
          No saved chats yet. Ask a question to start a thread.
        </div>
      ) : null}

      {!loading
        ? sessions.map((s) => {
            const active = String(s.id) === String(activeId);
            return (
              <div
                key={s.id}
                className={`spacer-ask-evans__sidebar-item${
                  active ? ' spacer-ask-evans__sidebar-item--active' : ''
                }`}
              >
                <button
                  type="button"
                  className="spacer-ask-evans__sidebar-item-main"
                  onClick={() => onSelect?.(s.id)}
                  title={s.title}
                >
                  <span className="spacer-ask-evans__sidebar-item-title">{s.title}</span>
                  <span className="spacer-ask-evans__sidebar-item-meta">
                    {formatChatRelativeTime(s.updatedAt || s.createdAt)}
                    {s.feature === 'rag_qa' ? ' · Docs' : s.feature === 'nl_qa' ? ' · Ops' : ''}
                  </span>
                </button>
                <Tooltip title="Delete chat">
                  <button
                    type="button"
                    className="spacer-ask-evans__sidebar-item-del"
                    aria-label="Delete chat"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete?.(s.id);
                    }}
                  >
                    <DeleteOutlined />
                  </button>
                </Tooltip>
              </div>
            );
          })
        : null}
    </div>
  </aside>
);

export default SpacerLogAiChatSidebar;
